import { datadogRum } from "@datadog/browser-rum";
import { Batch, BatchType, isBatchPending } from "../types/batch";

/**
 * Tracks e2e image generation latency in the tab that created the batch, from
 * creation to when polling reports it complete. Reports timing to Datadog RUM.
 *
 * The timer starts once the create request returns, so it leaves out the request
 * itself, and a tab closed before the batch completes reports nothing, which drops
 * the slowest runs. Compare with backend latency metrics with both in mind.
 */

// Batch types that produce images. Publishing, uploads, training, and video
// batches are not image generation and would skew the image latency numbers.
const IMAGE_GENERATION_BATCH_TYPES: ReadonlySet<BatchType> = new Set([
  BatchType.ImageGenerate,
  BatchType.ImageGenerateFromConcept,
  BatchType.VariationGenerate,
  BatchType.BulkImageGeneration,
  BatchType.ResizingImageGeneration,
  BatchType.AgenticGeneration
]);

const startTimes = new Map<number, number>();

export function startGenerationTimer(batch: Batch) {
  if (!IMAGE_GENERATION_BATCH_TYPES.has(batch.type) || !isBatchPending(batch.status)) return;

  startTimes.set(batch.id, performance.now());
}

export function completeGenerationTimer(batchId: number, context?: Record<string, string | number | boolean>) {
  const startTime = startTimes.get(batchId);
  if (startTime == null) return;

  const durationMs = performance.now() - startTime;
  startTimes.delete(batchId);

  datadogRum.addAction("image_generation_e2e", {
    duration_ms: Math.round(durationMs),
    batch_id: batchId,
    ...context
  });
}
